export const camelToKebabCase = (str: string) => str.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);

export const toEnumKey = (str: string) =>
  str
    // insert underscore between a lowercase/digit and uppercase letter
    .replace(/([a-z\d])([A-Z])/g, '$1_$2')
    // replace spaces or dashes with underscore
    .replace(/[\s-]+/g, '_')
    // uppercase the whole thing
    .toUpperCase();
